import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../api/axios';
import { signInWithGoogle, signOutFirebase } from '../firebase';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      fetchUserProfile();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchUserProfile = async () => {
    try {
      const response = await api.get('/api/auth/me');
      setUser(response.data.user);
    } catch (error) {
      console.error('Failed to fetch user profile:', error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (username, password) => {
    const response = await api.post('/api/auth/login', { username, password });
    const { token, user } = response.data;
    localStorage.setItem('token', token);
    setToken(token);
    setUser(user);
    return user;
  };

  const ssoLogin = async () => {
    const { idToken } = await signInWithGoogle();
    const response = await api.post('/api/auth/sso', { idToken });
    const { token: jwtToken, user } = response.data;
    localStorage.setItem('token', jwtToken);
    setToken(jwtToken);
    setUser(user);
    return user;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
    signOutFirebase();
  };

  const isAdmin = () => {
    if (!user) {
      return false;
    }
    return user.is_admin === true || user.original_role === 'admin' || user.role === 'admin';
  };

    const updateUser = (updatedUserData) => {
      setUser(updatedUserData);
    };

  return (
      <AuthContext.Provider value={{ user, token, loading, login, ssoLogin, logout, isAdmin, updateUser, fetchUserProfile }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
